
// import { useState, useEffect } from "react";
// import {
//   Button,
//   TextField,
//   IconButton,
//   Grid,
//   Typography,
//   Paper,
//   Avatar
// } from "@mui/material";
// import { Visibility, VisibilityOff } from "@mui/icons-material";
// import { useNavigate } from "react-router-dom";
// import Navbar from "./Navbar";
// import { collection, query, where, getDocs, doc, updateDoc } from "firebase/firestore";
// import { db } from "./Firebase";

// export default function Profile() {
//   const navigate = useNavigate();

//   const [userData, setUserData] = useState({
//     Name: "",
//     Email: "",
//     Password: "",
//     Address: "",
//     Contact: "",
//     Gender: "",
//     Dateofbirth: "",
//   });

//   const [docId, setDocId] = useState(null);
//   const [error, setError] = useState("");
//   const [isUpdating, setIsUpdating] = useState(false);
//   const [passwordVisible, setPasswordVisible] = useState(false);

//   const [profilePic, setProfilePic] = useState(localStorage.getItem("profilePic") || "");

//   useEffect(() => {
//     const email = localStorage.getItem("email");
//     if (!email) {
//       setError("Email not found in localStorage.");
//       return;
//     }

//     const fetchUserData = async () => {
//       try {
//         const q = query(collection(db, "Users"), where("Email", "==", email));
//         const querySnapshot = await getDocs(q);

//         if (!querySnapshot.empty) {
//           const docSnap = querySnapshot.docs[0];
//           const data = docSnap.data();
//           setUserData(data);
//           setDocId(docSnap.id);
//         } else {
//           setError("No user found with that email.");
//         }
//       } catch (err) {
//         console.error("Fetch error:", err);
//         setError("Failed to load profile data.");
//       }
//     };

//     fetchUserData();
//   }, []);

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setUserData((prev) => ({ ...prev, [name]: value }));
//   };

//   const handleProfilePicUpload = (e) => {
//     const file = e.target.files[0];
//     if (!file) return;
//     const reader = new FileReader();
//     reader.onloadend = () => {
//       const base64 = reader.result;
//       localStorage.setItem("profilePic", base64);
//       setProfilePic(base64);
//     };
//     reader.readAsDataURL(file);
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     setIsUpdating(true);
//     setError("");

//     if (!docId) {
//       setError("User document ID not found.");
//       setIsUpdating(false);
//       return;
//     }

//     try {
//       const userRef = doc(db, "Users", docId);
//       await updateDoc(userRef, userData);

//       localStorage.setItem("email", userData.Email);
//       setIsUpdating(false);
//       navigate("/");
//     } catch (err) {
//       console.error("Update error:", err);
//       setError("Failed to update profile.");
//       setIsUpdating(false);
//     }
//   };

//   const handleLogout = () => {
//     localStorage.clear();
//     navigate("/");
//   };

//   return (
//     <div className="profile-container">
//       <Navbar />
//       <Paper elevation={3} className="form-container">
//         <Typography variant="h4" align="center" gutterBottom>
//           User Profile
//         </Typography>

//         {/* Profile Picture */}
//         <div className="avatar-wrapper">
//           <Avatar
//             alt="Profile Picture"
//             src={profilePic}
//             sx={{ width: 120, height: 120, margin: "0 auto" }}
//           />
//           <input type="file" accept="image/*" onChange={handleProfilePicUpload} className="upload-input" />
//         </div>

//         <form onSubmit={handleSubmit} className="profile-form">
//           <Grid container spacing={2}>
//             <Grid item xs={12} md={6}>
//               <TextField
//                 label="Full Name"
//                 name="Name"
//                 value={userData.Name}
//                 onChange={handleChange}
//                 fullWidth
//                 required
//                 variant="outlined"
//               />
//             </Grid>
//             <Grid item xs={12} md={6}>
//               <TextField
//                 label="Email"
//                 name="Email"
//                 value={userData.Email}
//                 onChange={handleChange}
//                 fullWidth
//                 required
//                 variant="outlined"
//               />
//             </Grid>
//             <Grid item xs={12} md={6}>
//               <TextField
//                 label="Password"
//                 name="Password"
//                 type={passwordVisible ? "text" : "password"}
//                 value={userData.Password}
//                 onChange={handleChange}
//                 fullWidth
//                 required
//                 variant="outlined"
//                 InputProps={{
//                   endAdornment: (
//                     <IconButton onClick={() => setPasswordVisible((prev) => !prev)}>
//                       {passwordVisible ? <VisibilityOff /> : <Visibility />}
//                     </IconButton>
//                   ),
//                 }}
//               />
//             </Grid>
//             <Grid item xs={12} md={6}>
//               <TextField
//                 label="Contact"
//                 name="Contact"
//                 value={userData.Contact}
//                 onChange={handleChange}
//                 fullWidth
//                 variant="outlined"
//               />
//             </Grid>
//             <Grid item xs={12} md={6}>
//               <TextField
//                 label="Gender"
//                 name="Gender"
//                 value={userData.Gender}
//                 onChange={handleChange}
//                 fullWidth
//                 variant="outlined"
//               />
//             </Grid>
//             <Grid item xs={12} md={6}>
//               <TextField
//                 label="Date of Birth"
//                 name="Dateofbirth"
//                 type="date"
//                 value={userData.Dateofbirth}
//                 onChange={handleChange}
//                 fullWidth
//                 variant="outlined"
//                 InputLabelProps={{ shrink: true }}
//               />
//             </Grid>
//             <Grid item xs={12}>
//               <TextField
//                 label="Address"
//                 name="Address"
//                 value={userData.Address}
//                 onChange={handleChange}
//                 fullWidth
//                 variant="outlined"
//               />
//             </Grid>
//           </Grid>

//           {error && <p className="error-message">{error}</p>}

//           <Button
//             type="submit"
//             variant="contained"
//             color="primary"
//             disabled={isUpdating}
//             fullWidth
//             sx={{ mt: 3 }}
//           >
//             {isUpdating ? "Saving..." : "Save Changes"}
//           </Button>
//         </form>

//         <Button
//           variant="outlined"
//           color="secondary"
//           onClick={handleLogout}
//           fullWidth
//           sx={{ mt: 2 }}
//         >
//           Logout
//         </Button>
//       </Paper>

//       <style jsx>{`
//         .profile-container {
//           display: flex;
//           justify-content: center;
//           align-items: center;
//           min-height: 100vh;
//           background-color: #f9f9f9;
//           padding-top: 50px;
//         }

//         .form-container {
//           padding: 30px;
//           background: white;
//           border-radius: 12px;
//           max-width: 960px;
//           width: 100%;
//         }

//         .avatar-wrapper {
//           display: flex;
//           flex-direction: column;
//           align-items: center;
//           margin-bottom: 20px;
//         }

//         .upload-input {
//           margin-top: 10px;
//         }

//         .error-message {
//           color: red;
//           margin-top: 10px;
//         }

//         @media (max-width: 600px) {
//           .form-container {
//             padding: 15px;
//           }
//         }
//       `}</style>
//     </div>
//   );
// }


import { useState, useEffect } from "react";
import {
  Button,
  TextField,
  IconButton,
  Grid,
  Typography,
  Paper,
  Avatar
} from "@mui/material";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import Navbar from "./Navbar";
import { collection, query, where, getDocs, doc, updateDoc } from "firebase/firestore";
import { db } from "./Firebase";

export default function Profile() {
  const navigate = useNavigate();

  const [userData, setUserData] = useState({
    Name: "",
    Email: "",
    Password: "",
    Address: "",
    Contact: "",
    Gender: "",
    Dateofbirth: "",
  });

  const [docId, setDocId] = useState(null);
  const [error, setError] = useState("");
  const [isUpdating, setIsUpdating] = useState(false);
  const [passwordVisible, setPasswordVisible] = useState(false);

  const [profilePic, setProfilePic] = useState(localStorage.getItem("profilePic") || "");

  useEffect(() => {
    const email = localStorage.getItem("email");
    if (!email) {
      setError("Email not found in localStorage.");
      return;
    }

    const fetchUserData = async () => {
      try {
        const q = query(collection(db, "Users"), where("Email", "==", email));
        const querySnapshot = await getDocs(q);

        if (!querySnapshot.empty) {
          const docSnap = querySnapshot.docs[0];
          const data = docSnap.data();
          setUserData(data);
          setDocId(docSnap.id);
        } else {
          setError("No user found with that email.");
        }
      } catch (err) {
        console.error("Fetch error:", err);
        setError("Failed to load profile data.");
      }
    };

    fetchUserData();
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setUserData((prev) => ({ ...prev, [name]: value }));
  };

  const handleProfilePicUpload = (e) => {
    const file = e.target.files[0];
    if (!file) return;
    const reader = new FileReader();
    reader.onloadend = () => {
      const base64 = reader.result;
      localStorage.setItem("profilePic", base64);
      setProfilePic(base64);
    };
    reader.readAsDataURL(file);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsUpdating(true);
    setError("");

    if (!docId) {
      setError("User document ID not found.");
      setIsUpdating(false);
      return;
    }

    try {
      const userRef = doc(db, "Users", docId);
      await updateDoc(userRef, userData);

      localStorage.setItem("email", userData.Email);
      setIsUpdating(false);
      navigate("/");
    } catch (err) {
      console.error("Update error:", err);
      setError("Failed to update profile.");
      setIsUpdating(false);
    }
  };

  const handleLogout = () => {
    localStorage.clear();
    navigate("/");
  };

  return (
    <div className="profile-container">
      <Navbar />
      <Paper elevation={12} className="form-container">
        <Typography variant="h4" align="center" gutterBottom>
          User Profile
        </Typography>

        {/* Profile Picture */}
        <div className="avatar-wrapper">
          <Avatar
            alt="Profile Picture"
            src={profilePic}
            sx={{
              width: 120,
              height: 120,
              margin: "0 auto",
              transition: "all 0.3s ease",
              boxShadow: "0 4px 8px rgba(0,0,0,0.2)"
            }}
            className="avatar"
          />
          <input
            type="file"
            accept="image/*"
            onChange={handleProfilePicUpload}
            className="upload-input"
          />
        </div>

        <form onSubmit={handleSubmit} className="profile-form">
          <Grid container spacing={2}>
            <Grid item xs={12} md={6}>
              <TextField
                label="Full Name"
                name="Name"
                value={userData.Name}
                onChange={handleChange}
                fullWidth
                required
                variant="outlined"
                className="input-field"
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <TextField
                label="Email"
                name="Email"
                value={userData.Email}
                onChange={handleChange}
                fullWidth
                required
                variant="outlined"
                className="input-field"
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <TextField
                label="Password"
                name="Password"
                type={passwordVisible ? "text" : "password"}
                value={userData.Password}
                onChange={handleChange}
                fullWidth
                required
                variant="outlined"
                InputProps={{
                  endAdornment: (
                    <IconButton onClick={() => setPasswordVisible((prev) => !prev)}>
                      {passwordVisible ? <VisibilityOff /> : <Visibility />}
                    </IconButton>
                  ),
                }}
                className="input-field"
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <TextField
                label="Contact"
                name="Contact"
                value={userData.Contact}
                onChange={handleChange}
                fullWidth
                variant="outlined"
                className="input-field"
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <TextField
                label="Gender"
                name="Gender"
                value={userData.Gender}
                onChange={handleChange}
                fullWidth
                variant="outlined"
                className="input-field"
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <TextField
                label="Date of Birth"
                name="Dateofbirth"
                type="date"
                value={userData.Dateofbirth}
                onChange={handleChange}
                fullWidth
                variant="outlined"
                InputLabelProps={{ shrink: true }}
                className="input-field"
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                label="Address"
                name="Address"
                value={userData.Address}
                onChange={handleChange}
                fullWidth
                variant="outlined"
                className="input-field"
              />
            </Grid>
          </Grid>

          {error && <p className="error-message">{error}</p>}

          <Button
            type="submit"
            variant="contained"
            color="primary"
            disabled={isUpdating}
            fullWidth
            sx={{ mt: 3 }}
            className="submit-button"
          >
            {isUpdating ? "Saving..." : "Save Changes"}
          </Button>
        </form>

        <Button
          variant="outlined"
          color="secondary"
          onClick={handleLogout}
          fullWidth
          sx={{ mt: 2 }}
          className="logout-button"
        >
          Logout
        </Button>
      </Paper>

      <style jsx>{`
        .profile-container {
          display: flex;
          justify-content: center;
          align-items: center;
          min-height: 100vh;
          background-color: #f0f4f7;
          padding-top: 50px;
          animation: fadeIn 1s ease-in-out;
          background: url('https://png.pngtree.com/thumb_back/fh260/back_our/20190625/ourmid/pngtree-simple-small-fresh-watercolor-company-profile-ppt-background-image_260406.jpg') no-repeat center center fixed;
          background-size: cover;
          animation: backgroundAnimation 30s infinite alternate;
        }

        @keyframes backgroundAnimation {
          0% {
            background-position: top left;
          }
          50% {
            background-position: bottom right;
          }
          100% {
            background-position: top left;
          }
        }

        .form-container {
          padding: 30px;
          background: transparent;
          border-radius: 12px;
          max-width: 960px;
          width: 100%;
          box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
        }

        .avatar-wrapper {
          display: flex;
          flex-direction: column;
          align-items: center;
          margin-bottom: 20px;
        }

        .upload-input {
          margin-top: 10px;
          display: none;
        }

        .avatar:hover {
          filter: brightness(1.2);
          transform: scale(1.1);
        }

        .input-field {
          transition: background-color 0.3s ease;
        }

        .input-field:hover {
          background-color: #f7f7f7;
        }

        .submit-button {
          background: linear-gradient(45deg, #6a11cb 0%, #2575fc 100%);
          box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
        }

        .submit-button:hover {
          background: linear-gradient(45deg, #2575fc 0%, #6a11cb 100%);
          transform: scale(1.05);
        }

        .logout-button {
          color: #f44336;
        }

        .logout-button:hover {
          background: #f44336;
          color: white;
        }

        .error-message {
          color: red;
          margin-top: 10px;
        }

        @keyframes fadeIn {
          from {
            opacity: 0;
          }
          to {
            opacity: 1;
          }
        }

        @media (max-width: 600px) {
          .form-container {
            padding: 15px;
          }
        }
      `}</style>
    </div>
  );
}
